import { StringUtils } from "@grandvisionhq/utils";
const DAY_IN_MS = 24 * 60 * 60 * 1e3;
const DAY_NAMES = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const getDayName = (date) => {
  let day;
  const dayOfWeek = new Date(date).getDay() - 1;
  if (dayOfWeek < 0) {
    day = DAY_NAMES[DAY_NAMES.length - 1];
  } else if (dayOfWeek >= 0 && dayOfWeek < DAY_NAMES.length) {
    day = DAY_NAMES[dayOfWeek];
  }
  if (!day) {
    throw new Error("Invalid day index");
  }
  return `https://schema.org/${StringUtils.upFirst(day)}`;
};
const getSpecialOpeningHours = (specialOpeningHours) => {
  let i = 0;
  return [...specialOpeningHours].sort((a, b) => Date.parse(a.dateOpenClosed) - Date.parse(b.dateOpenClosed)).reduce((acc, item) => {
    const current = acc[i];
    const lastDateInCurrent = current?.[current.length - 1]?.dateOpenClosed;
    const a = lastDateInCurrent ? Date.parse(lastDateInCurrent) : 0;
    const b = Date.parse(item.dateOpenClosed);
    if (current && b - a > DAY_IN_MS) {
      i++;
    }
    if (current && current.length > 0) {
      if (current[0]?.openClosed !== item.openClosed) {
        i++;
      } else if (current[0].openClosedTime && item.openClosedTime) {
        const sameOpenClosedTime = current[0].openClosedTime.every((time, i2) => {
          if (!item.openClosedTime || !item.openClosedTime[i2]) {
            return false;
          }
          return time.open === item.openClosedTime[i2]?.open && time.close === item.openClosedTime[i2]?.close;
        });
        if (!sameOpenClosedTime) {
          i++;
        }
      }
    }
    if (!acc[i]) {
      acc[i] = [];
    }
    acc[i]?.push(item);
    return acc;
  }, []).reduce((acc, period) => {
    const first = period[0];
    const last = period[period.length - 1];
    const dayOfWeek = period.length > 1 ? period.map((day) => getDayName(day.dateOpenClosed)) : getDayName(first?.dateOpenClosed || "");
    let opens = "00:00";
    let closes = "00:00";
    if (first?.openClosed === "OPEN" && first.openClosedTime) {
      opens = first.openClosedTime[0]?.open || opens;
      closes = first.openClosedTime[0]?.close || closes;
    }
    acc.push({
      "@type": "OpeningHoursSpecification",
      dayOfWeek,
      opens,
      closes,
      validFrom: first?.dateOpenClosed,
      validThrough: last?.dateOpenClosed
    });
    return acc;
  }, []);
};
export {
  getSpecialOpeningHours
};
//# sourceMappingURL=get-special-opening-hours.js.map
